import { useMutation } from '@tanstack/react-query';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { API_HANDLERS } from 'api/apiHandlers';
import { NewConfirmDialog } from 'components';
interface ClearDataModalProps {
  isOpen: boolean;
  handleCloseModal: () => void;
  closeMockDataBanner: () => void;
}

export function ClearDataModal({
  isOpen,
  handleCloseModal,
  closeMockDataBanner,
}: ClearDataModalProps): ReactElement {
  const { t } = useTranslation();
  const { mutateAsync: clearData, isLoading } = useMutation(API_HANDLERS.DEMO.CLEAR);

  async function handleSubmit() {
    await clearData();
    closeMockDataBanner();
    handleCloseModal();
  }

  return (
    <NewConfirmDialog
      title={t('mockedData.modalTitle')}
      subTitle={t('mockedData.modalDescription')}
      open={isOpen}
      onClose={handleCloseModal}
      onConfirm={handleSubmit}
      isLoading={isLoading}
      contentSx={{ padding: 0, overflow: 'hidden' }}
      submitLabel={t('mockedData.successButton')}
      cancelLabel={t('mockedData.cancelButton')}
    />
  );
}
